module.exports = __webpack_public_path__ + "img/SC2-Disclaimer.d0756747.png";